import { useState } from "react";
import { useI18n } from "../../i18n";
import {
  deleteAllData,
  exportAllData,
  initializeStorage,
} from "../../lib/storage";

function downloadJson(content: string): void {
  const url = URL.createObjectURL(
    new Blob([content], { type: "application/json" }),
  );
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `deskflow-backup-${new Date().toISOString().slice(0, 10)}.json`;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function Privacy({
  meetingCount,
  todoCount,
  onDeleted,
}: {
  meetingCount: number;
  todoCount: number;
  onDeleted: () => Promise<void>;
}): React.JSX.Element {
  const { t } = useI18n();
  const [notice, setNotice] = useState("");
  const erase = async (): Promise<void> => {
    if (!confirm(t("privacy.deleteConfirm"))) return;
    await deleteAllData();
    await initializeStorage();
    await onDeleted();
    setNotice(t("privacy.deleted"));
  };
  return (
    <div className="privacy-grid">
      <section className="panel privacy-main">
        <div className="privacy-hero">
          <div className="shield">✓</div>
          <div>
            <small>{t("nav.local")}</small>
            <h2>{t("privacy.title")}</h2>
            <p>{t("privacy.body")}</p>
          </div>
        </div>
        <div className="storage-count">
          <strong>{meetingCount}</strong>
          <span>{t("privacy.meetingCount")}</span>
          <strong>{todoCount}</strong>
          <span>{t("privacy.todoCount")}</span>
        </div>
        {notice && <p className="notice success">{notice}</p>}
        <div className="privacy-actions">
          <button
            className="secondary"
            onClick={() => void exportAllData().then(downloadJson)}
          >
            {t("privacy.export")}
          </button>
          <button className="danger-button" onClick={() => void erase()}>
            {t("privacy.delete")}
          </button>
        </div>
      </section>
      <aside className="privacy-side">
        <article className="panel">
          <small>BYOK</small>
          <h2>{t("privacy.aiTitle")}</h2>
          <p>{t("privacy.aiBody")}</p>
        </article>
        <article className="panel">
          <small>INDEXEDDB</small>
          <h2>{t("privacy.storageTitle")}</h2>
          <p>{t("privacy.storageBody")}</p>
        </article>
      </aside>
    </div>
  );
}
